import { render, staticRenderFns } from "./ProductionFacility.vue?vue&type=template&id=595758d9&scoped=true&"
import script from "./ProductionFacility.vue?vue&type=script&lang=js&"
export * from "./ProductionFacility.vue?vue&type=script&lang=js&"
import style0 from "./ProductionFacility.vue?vue&type=style&index=0&id=595758d9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595758d9",
  null
  
)

export default component.exports